export enum ScanEventEnum {
    ADD_DEVICE = '/add_device',
}
